import React from "react";
import DeviceSetup from "../../DeviceSetup";

const WifiComp: React.FC = () => {
  return <DeviceSetup />;
};

export default WifiComp;
